import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileBend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileBend"><Path d="M12 2H4V22H20V10H12V2Z" fill="currentColor"/><Path d="M19.4142 7.99991L14 2.58569V7.99991H19.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileBend;
